import { html, nothing, TemplateResult } from 'lit-html';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { ButtonComponent, InputComponent, LabelComponent } from '@components/common';

const FormTemplate = (props: IUpdatePasswordModel): TemplateResult => {
  const {
    messages,
    loading,
    inputType,
    formData,
    formSubmitted,
    formError,
    genericError,
    handleSubmit,
    togglePasswordInput,
    handlePasswordInput,
    close
  } = props;

  const submitError = formSubmitted && (formError || genericError);

  return html`
      <form class='add-pwd-form' name='forms.setPassword' novalidate @submit=${handleSubmit}>
        <div class='proposal-form__box'>
          <div class='proposal-form__field'>
            ${InputComponent({
              type: 'text',
              placeholder: messages.SearchWhat,
              cssClasses: 'jr-input jr-input-material jr-input-material--disabled',
              value: formData.what,
              options: { disabled: true }
            })}
          </div>
          <div class='proposal-form__field'>
            ${InputComponent({
              type: 'text',
              placeholder: messages.SearchWhere,
              cssClasses: 'jr-input jr-input-material jr-input-material--disabled',
              value: formData.where,
              options: { disabled: true }
            })}
          </div>
        </div>
        <div class='proposal-form__field'>
          ${InputComponent({
            type: 'text',
            cssClasses: 'jr-input jr-input-material jr-input-material--disabled',
            value: formData.jobSeekerEmail,
            options: { disabled: true }
          })}
          </div>
        <div class="add-pwd-form___field ${submitError ? 'add-pwd-form___field--error': ''}">
          <div class='proposal-form--error-message'>
            ${formError === 'pattern' ? html `
              <span>${unsafeHTML(messages.JobSeekerSubscriptionDialogInvalidPasswordPatternWarn)}</span>
              ` :
              nothing
            }
            ${formError === 'required' ? html `
              <span>${unsafeHTML(messages.JobSeekerSubscriptionDialogInvalidPasswordWarn)}</span>
              ` :
              nothing
            }
            ${genericError ? html `
              <span>${unsafeHTML(messages.JobSeekerSubscriptionDialogInvalidPasswordGenericError)}</span>
              ` :
              nothing
            }
          </div>
          <div class='add-pwd-form__pwd-wrapper'>
            ${LabelComponent({
              cssClasses: 'proposal-form__label',
              labelText:'password'
            })}
            ${InputComponent({
              type: inputType,
              name: 'password',
              placeholder: messages.RegistrationPasswordLabel,
              cssClasses: `jr-input jr-input-material jr-input--right-icon ${submitError ? 'jr-input--invalid' : ''}`,
              value: formData.password,
              options: { pattern: '^.{6,}$', required: true, autofocus: true },
              eventHandlers: {onInput: handlePasswordInput}
            })}
            ${InputComponent({
              id: 'showPassword',
              type: 'checkbox',
              cssClasses: 'check-password-input',
              eventHandlers: { onChange: togglePasswordInput },
            })}
            ${LabelComponent({
              labelFor: 'showPassword',
              cssClasses: `check-password ${inputType === 'password' ? 'hide-password' : 'show-password'}`
            })}
          </div>
        </div>
        <div class='row-fluid btn-container'>
          ${ButtonComponent({ type: 'submit', id:'add-password', cssClasses: `jr-button jr-button-material ${loading ? 'jr-button--loading' : ''}`, btnText: messages.JobSeekerConfirmDialogAddPasswordButton})}
          ${ButtonComponent({ type: 'button', cssClasses: 'jr-button jr-button-material jr-button-material--textual', btnText: messages.MySearchesDIVButtonNo, eventHandlers: { onClick: close } })}
        </div>
      </form>
    `;
}

export default FormTemplate;